"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = void 0;
const themes = {
  white: {
    theme: "white",
    color: "#252A2E",
    backgroundColor: "#FFFFFF",
    darkTheme: false,
    iconColor: "#252A2E",
    accordionIconColor: "#0063A3"
  },
  blue: {
    theme: "blue",
    color: "#FFFFFF",
    backgroundColor: "#0063A3",
    darkTheme: true,
    iconColor: "#FFFFFF",
    accordionIconColor: "#89C6ED"
  },
  darkGray: {
    theme: "dark-gray",
    color: "#FFFFFF",
    backgroundColor: "#252A2E",
    darkTheme: true,
    iconColor: "#FFFFFF",
    accordionIconColor: "#FFFFFF"
  },
  darkNavy: {
    theme: "dark-navy",
    color: "#FFFFFF",
    backgroundColor: "#003054",
    darkTheme: true,
    iconColor: "#FFFFFF",
    accordionIconColor: "#FFFFFF"
  },
  concreteGray: {
    theme: "concrete-gray",
    color: "#252A2E",
    backgroundColor: "#F1F1F6",
    darkTheme: false,
    iconColor: "#252A2E",
    accordionIconColor: "#0063A3"
  },
  transparentDarkText: {
    theme: "transparent-dark-text",
    color: "#252A2E",
    backgroundColor: "unset",
    darkTheme: false,
    iconColor: "#252A2E",
    accordionIconColor: "#0063A3"
  },
  transparentLightText: {
    theme: "transparent-light-text",
    color: "#FFFFFF",
    backgroundColor: "unset",
    darkTheme: false,
    iconColor: "#FFFFFF",
    accordionIconColor: "#FFFFFF"
  }
};
exports.themes = themes;